import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { Draggable } from '@wordpress/components';
/**
 * Internal dependencies
 */

import BlockDraggableChip from '../block-draggable/draggable-chip';

const InserterDraggableBlocks = _ref => {
  let {
    isEnabled,
    blocks,
    icon,
    children
  } = _ref;
  const transferData = {
    type: 'inserter',
    blocks
  };
  return createElement(Draggable, {
    __experimentalTransferDataType: "wp-blocks",
    transferData: transferData,
    __experimentalDragComponent: createElement(BlockDraggableChip, {
      count: blocks.length,
      icon: icon
    })
  }, _ref2 => {
    let {
      onDraggableStart,
      onDraggableEnd
    } = _ref2;
    return children({
      draggable: isEnabled,
      onDragStart: isEnabled ? onDraggableStart : undefined,
      onDragEnd: isEnabled ? onDraggableEnd : undefined
    });
  });
};

export default InserterDraggableBlocks;
//# sourceMappingURL=index.js.map